exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrolling-disabled{height:100%;overflow:hidden}#container{position:relative;overflow:hidden;min-height:100vh;z-index:2;box-sizing:border-box;padding-top:5rem}.main-background-image{position:fixed;top:0;right:0;bottom:0;left:0;width:100%;height:100vh;z-index:-1;background-repeat:no-repeat;background-size:cover;background-position:50%}.wrap{margin:0 auto;padding:0 15vw 160px;position:relative}@media screen and (max-width:620px){.wrap{padding:0 10vw 100px}}", ""]);

// exports
